import Vue from "vue";

import Ionic from "@ionic/vue";
import Vue2TouchEvents from "vue2-touch-events";

Vue.use(Vue2TouchEvents);
Vue.use(Ionic);

import { addIcons } from "ionicons";
import {
  iosArrowBack,
  iosArrowForward,
  mdArrowBack,
  mdArrowForward,
  iosText,
  mdText,
  mdCamera,
  iosCamera,
  mdQrScanner,
  iosQrScanner,
  iosClose,
  mdClose,
  iosTrash,
  mdTrash,
  iosImage,
  mdImage
} from "ionicons/icons";
import { defineCustomElements } from "@ionic/pwa-elements/loader";

addIcons({
  "md-arrow-back": mdArrowBack,
  "ios-arrow-back": iosArrowBack,
  "md-arrow-forward": mdArrowForward,
  "ios-arrow-forward": iosArrowForward,
  "ios-text": iosText,
  "md-text": mdText,
  "md-camera": mdCamera,
  "ios-camera": iosCamera,
  "md-qr-scanner": mdQrScanner,
  "ios-qr-scanner": iosQrScanner,
  "md-close": mdClose,
  "ios-close": iosClose,
  "ios-trash": iosTrash,
  "md-trash": mdTrash,
  "ios-image": iosImage,
  "md-image": mdImage
});

defineCustomElements(window);

import "@ionic/core/css/ionic.bundle.css";

import "./registerServiceWorker";

import { router } from "./router";
import { store } from "./store";

import App from "./App.vue";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

/**
 * iOS touch zoom fixes...... *sigh*
 */

// Remove pinch-to-zoom
document.addEventListener(
  "touchmove",
  function(e) {
    if (e.scale !== 1) {
      e.preventDefault();
    }
  },
  false
);

// Remove double-tap-to-zoom
let lastTouchEnd = 0;
document.addEventListener(
  "touchend",
  function(e) {
    let now = new Date().getTime();
    if (now - lastTouchEnd <= 300) {
      e.preventDefault();
    }
    lastTouchEnd = now;
  },
  false
);
